<!--
This component generates the pass list group for the specified {{status}.
Receiver must pass an array to {passData} to let the component generate the proper ui.
-->
<template>
  <section class="pass-section"> <!--ACTIVE-->
    <div class="pass-status-header">
      <div class="pass-status-indicator" v-bind:class="statusObject"></div>
      <div class="pass-status-title">{{ status }}</div>
    </div>

    <div class="list-group-container">
      <div class="d-flex flex-row list-row-header" v-if="status !== 'Inactive'">
        <div class="p-2 w-50">Name</div>
        <div class="p-2 w-25">Valid from</div>
        <div class="p-2 w-25">Valid until</div>
        <!-- <div class="px-2 list-column-action" v-if="isEditable"></div> -->
      </div>
      <div class="d-flex flex-row list-row-header" v-else>
        <div class="p-2 w-50">Name</div>
        <div class="p-2 w-25">Inactive Since</div>
        <div class="p-2 w-25">Status</div>
        <div class="px-2 list-column-action"></div>
      </div>

      <!--Appears if there's no active pass-->
      <div class="d-flex flex-row list-row-empty" v-if="passData.length === 0">
        <div class="flex-fill">No {{ status }} pass.</div>
      </div>
      <!--end no active pass-->

      <!-- business table -->
      <div class="list-rows" v-if="passData.length >= 1 && accountType === 'business'">
        <div v-for="(data, index) in passData" :key="index" class="d-flex flex-row list-row">
          <!-- 1st column-->
          <div class="px-2 w-50 list-column-item d-flex flex-row">
            <img v-if="accountType === 'individual'"
              class="rounded-circle" :src="data.company_logo" alt="..."/>
            <router-link class="simple-link" v-bind:to="{ name: 'PassDetailView', params: { id: data.id } }">
              {{ data.pass_name }}
            </router-link>
          </div>

          <!-- 2nd column -->
          <div class="px-2 w-25 list-column-item">
            {{ data.visiting_date }} - {{ data.visiting_time }}
          </div>

          <!-- 3rd column -->
          <div class="px-2 w-25 list-column-item" v-if="status === 'Active' || status === 'Pending'">
            {{ data.validity_date }} - {{ data.validity_time }}
          </div>
          <div v-else> {{ data.status }} </div>

          <!-- 4th column: show edit if editable
          //Hide edit button
          <div class="px-2 flex-shrink-1 list-column-action"
            v-if="isEditable && (data.status === 'Active' || data.status === 'Pending')">
            <button class="simple-link">
              <router-link class="simple-link" :toEdit="true"
                v-bind:to="{ name: 'PassDetailView', params: { id: data.id } }">
                Edit
              </router-link>
            </button>
          </div>
          <div class="px-2 flex-shrink-1 list-column-action" v-else></div> -->
        </div>
      </div>

      <!-- individual table -->
      <div class="list-rows" v-if="passData.length >= 1 && accountType === 'individual'">
        <div v-for="(data, index) in passData" :key="index" class="d-flex flex-row list-row">
          <!-- 1st column -->
          <div v-bind:class="firstColumnClass">
            <img v-if="accountType === 'individual'" class="rounded-circle"
              :src="data.pass_details.company_logo_url"
              alt="Company Logo"/>
            <router-link class="simple-link" v-if="data.pass_status === 'Waiting for approval'"
              v-bind:to="{ name: 'InvitePasses', params: { link_id: data.reference_link_id } }">
              {{ data.pass_details.pass_name }} - {{ data.pass_status }}
            </router-link>
            <router-link class="simple-link" v-else
              v-bind:to="{ name: 'InvitePasses', params: { link_id: data.reference_link_id } }">
              {{ data.pass_details.pass_name }}
            </router-link>
          </div>

          <!-- 2nd column -->
          <div v-if="status === 'Active' || status === 'Pending'" class="px-2 w-25 list-column-item">
            {{ data.pass_details.visiting_date }} - {{ data.pass_details.visiting_time }}
          </div>
          <div v-else class="px-2 w-25 list-column-item">
            {{ convertUnixToDateTimeFormat(data.date_updated) }}
          </div>

          <!-- 3rd column -->
          <div v-if="status === 'Active' || status === 'Pending'" class="px-2 w-25 list-column-item">
            {{ data.pass_details.validity_date }} - {{ data.pass_details.validity_time }}
          </div>
          <div v-else class="px-2 w-25 list-column-item">
            {{ data.pass_status }}
          </div>
        </div>
      </div>
    </div>
    <!--end list group-->
  </section>
</template>

<script>
import '@/assets/styles/list-style.css'

export default {
  name: 'pass-list-view',
  data() {
    return { }
  },
  props: {
    status: String,
    accountType: String,
    passData: Array,
    convertUnixToDateTimeFormat: Function
  },
  computed: {
    statusObject: function () {
      return {
        'status-active': this.status === "Active",
        'status-inactive': this.status === "Inactive",
        'status-pending': this.status === "Pending"
      }
    },
    firstColumnClass: function () {
      return this.status !== 'Inactive'
        ? 'w-50 list-column-item d-flex flex-row'
        : 'w-50 list-column-item d-flex flex-row'
    }
  }
}
</script>

<style scoped>
.pass-section {
  margin-top: 48px;
}
.pass-status-header {
  display:flex;
  align-items: center;
}
.pass-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.pass-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}

/* hide rounded circle on small phones */
@media only screen and (max-width: 520px) {
  /deep/.rounded-circle {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/listview/PassListView.vue